export default __webpack_public_path__ + "static/media/latearrivalvector.94e341d6.svg";